import React from 'react'

import { CircleCheckmarkLineIcon, IconSizes } from '@inno-ui/icons'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import { PASSWORD_RULES } from 'shared/schemas/password.schema'

import styles from './PasswordRequirements.module.scss'
import { PasswordRequirementsProps } from './PasswordRequirements.types'

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  className
}) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'password_requirements'
  })

  return (
    <ul className={cn(styles.requirements, className)}>
      {PASSWORD_RULES.map(rule => {
        const isMet = rule.test(password)
        return (
          <li
            key={rule.key}
            className={cn(styles.rule, { [styles.ruleMet]: isMet })}
            data-met={isMet}
          >
            {isMet ? (
              <CircleCheckmarkLineIcon
                size={IconSizes.Size16}
                color='var(--warning-green-light)'
                className={styles.icon}
              />
            ) : (
              <span className={styles.dot} />
            )}
            <span>{t(rule.key)}</span>
          </li>
        )
      })}
    </ul>
  )
}
